export default {
  computed: {
    formfields () {
      return [
        {
          text: 'Módulo',
          value: 'acesso_modulo_id',
          select: [],
          relation: {
            url: '/admin/acessomodulos',
            text: 'titulo',
            value: 'id'
          },
          required: true
        },
        {
          text: 'Descrição',
          value: 'descricao',
          required: true
        },
        {
          text: 'Identificação',
          value: 'identificacao',
          required: true
        },
        {
          text: 'Sequência',
          value: 'sequencia',
          required: true
        },
        {
          text: 'Ícone',
          value: 'icone',
          required: true
        },
        {
          text: 'Web Url',
          value: 'web_url',
          required: true
        },
        {
          text: 'Ativo',
          value: 'ativo',
          select: [
            { text: 'Sim', value: 'S' },
            { text: 'Não', value: 'N' }
          ]
        }
      ]
    }
  }
}
